import { useState } from 'react';

import { ComplianceTypes, Modals } from '@/constants';
import {
  selectActiveModalParams,
  selectEpisodeCompliance,
  selectSessionUserId,
  selectUserAudienceRegions,
  useAppSelector,
  useFetchRecommendedEpisodesQuery,
} from '@/store';
import { appStyles } from '@/theme';

import { AppModal } from '../AppModal';
import { ChapterQuizModalContent } from './ChapterQuizModalContent.container';

export const ChapterQuizModal = () => {
  const [isOnCompletionStep, setIsOnCompletionStep] = useState(false);
  const { episodeId } = useAppSelector(selectActiveModalParams) || {};

  const compliance = useAppSelector(state =>
    selectEpisodeCompliance(state, episodeId),
  );
  const audienceRegions = useAppSelector(selectUserAudienceRegions);
  const userId = useAppSelector(selectSessionUserId);

  useFetchRecommendedEpisodesQuery(
    {
      compliance,
      audienceRegions,
    },
    { skip: !userId },
  );

  const isCPE = compliance === ComplianceTypes.CPE;

  return (
    <AppModal
      modalName={Modals.CHAPTER_QUIZ}
      scroll="paper"
      maxWidth={false}
      hidePaper={isOnCompletionStep && !isCPE}
      sx={appStyles.scrollbar}
      onClose={() => {
        setTimeout(() => {
          setIsOnCompletionStep(false);
        }, 1000);
      }}>
      <ChapterQuizModalContent
        setIsOnCompletionStep={setIsOnCompletionStep}
        isOnCompletionStep={isOnCompletionStep}
      />
    </AppModal>
  );
};
